<template>
  <q-list separator>
    <q-item v-if="showLabel">
      <q-item-section>
        <q-item-label class="text-h5 text-black">
          Account Manager
        </q-item-label>
      </q-item-section>
    </q-item>
    <q-item
      v-for="accountManager in accountManagers"
      :key="accountManager.id"
    >
      <q-item-section>
        <q-item-label class="row">
          <div
            v-if="!accountManager.user.hasPhoto"
            class="col-auto circle-with-text upcase text-body2 col q-mr-sm"
            style="position: relative;"
            :style="'background-color: #' + accountManager.user.getColorForUser() + ';'"
          >
            {{ accountManager.user.firstName?.charAt(0) || '' }}{{ accountManager.user.lastName?.charAt(0) || '' }}
          </div>
          <div v-else>
            <q-avatar
              size="50"
              class="q-mr-sm"
            >
              <img :src="accountManager.user.photoUrl">
            </q-avatar>
          </div>
          <div class="column">
            <div class="text-h5 text-black">
              {{ accountManager.user.firstName }} {{ accountManager.user.lastName }}
            </div>
            <div v-if="accountManager.user.email">
              <q-icon
                size="sm"
                class="q-mr-sm"
                name="email"
              />
              <a
                v-if="allowContactNavigation"
                :href="`mailto:${accountManager.user.email}`"
              >{{ accountManager.user.email }}</a>
              <span v-else>{{ accountManager.user.email }}</span>
            </div>
            <div v-if="!accountManager.hidePhone && accountManager.user.phone">
              <q-icon
                size="sm"
                class="q-mr-sm"
                name="call"
              />
              <a
                v-if="allowContactNavigation"
                :href="`tel:${accountManager.user.phone}`"
              > {{ accountManager.user.phone }} </a>
              <span v-else>{{ accountManager.user.phone }}</span>
            </div>
          </div>
        </q-item-label>
      </q-item-section>

      <q-item-section
        v-if="!simple"
        side
        top
      >
        <q-item-label caption>
          Assigned On
        </q-item-label>
        <q-item-label>
          <formatted-date
            :value="accountManager.createdAt"
            format="short"
          />
        </q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'

export default {
  name: 'AccountManagerList',
  components: {
    FormattedDate
  },
  props: {
    showLabel: {
      type: Boolean,
      default: false
    },
    allowContactNavigation: {
      type: Boolean,
      default: true
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    accountManagers () {
      return this.currentCircuit.accountManagers.data
    }
  },
  models: {
    currentCircuit: {
      accountManagers: {
        user: true
      },
      immediate: true
    }
  },
  context: ['currentUser']
}

</script>
<style scoped>
.circle-with-text {
  border-radius: 100%;
  text-align: center;
  width: 50px;
  height: 50px;
  padding: 0;
  border: solid 1px #444;
  font-size: 30px;
  font-weight: 500;
  line-height: 50px;
}
</style>
